import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { defaultStyles } from 'utils/Theme';
import { authSelector } from 'redux/auth/selectors';
import { useSelector } from 'react-redux';

const MoreActionsMenu = ({ changePasswordRequest, userId }) => {
    const classes = defaultStyles();
    const { user: loggedInUser } = useSelector(authSelector);

    return (
        <div className="o-line">
            <h3
                className={`${classes.colorPrimary} u-text-capitalize u-pt-zero u-mt-zero u-pb-small`}
            >
                Edit User
            </h3>
            <div className="c-dropdown dropdown">
                <span
                    className={`c-btn ${classes.buttonPrimary} has-icon dropdown-toggle`}
                    id="MoreActionsDropdown"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    More Actions
                </span>

                <div
                    className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                    aria-labelledby="MoreActionsDropdown"
                >
                    <span
                        className="c-dropdown__item dropdown-item c-tooltip c-tooltip--top"
                        aria-label="Send password change email"
                        onClick={changePasswordRequest}
                    >
                        Password Change
                    </span>
                    <Link
                        to={`/settings/users/view/${userId}`}
                        className="c-dropdown__item dropdown-item"
                    >
                        View User
                    </Link>
                    {loggedInUser.role === 'Admin' ? (
                        <Link
                            className={'c-dropdown__item dropdown-item'}
                            to={`/settings/users/delete/${userId}`}
                        >
                            Delete User
                        </Link>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default MoreActionsMenu;

MoreActionsMenu.propTypes = {
    changePasswordRequest: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
};
